import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArticleService from "../services/ArticleService";

const ArticleCard = ({ article }) => {
  const publishedDate = article.publishedOn
    ? new Date(article.publishedOn).toLocaleDateString()
    : null;

  return (
    <Link
      to={`/articles/${article.slug}`}
      className="block rounded-2xl border border-slate-200 bg-white overflow-hidden hover:shadow-md transition no-underline"
      title={article.title}
    >
      {article.imageUrl && (
        <img
          src={article.imageUrl}
          alt={article.imageAltText || article.title}
          className="w-full h-40 object-cover"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = "/images/college-banner.jpg";
          }}
        />
      )}
      <div className="p-4">
        {article.categoryName && (
          <div className="text-xs font-semibold text-brand-600 mb-1">
            {article.categoryName}
          </div>
        )}
        <h3 className="text-base font-bold text-slate-900 leading-snug">
          {article.title}
        </h3>
        <div className="mt-2 text-xs text-slate-500 flex items-center justify-between">
          <span>{article.authorDisplayName}</span>
          {publishedDate && <span>{publishedDate}</span>}
        </div>
      </div>
    </Link>
  );
};

const NewsArticlesSection = ({ numberofCards = 4 }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ArticleService.getArticles({ page: 1, size: numberofCards })
      .then((response) => setArticles(response?.data?.content || []))
      .catch((error) => {
        console.error("Error fetching articles:", error);
        setArticles([]);
      })
      .finally(() => setLoading(false));
  }, [numberofCards]);

  if (loading) {
    return <div className="text-sm text-slate-500">Loading articles...</div>;
  }

  if (articles.length === 0) {
    return <div className="text-sm text-slate-500">No articles published yet.</div>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {articles.map((article) => (
        <ArticleCard key={article.id} article={article} />
      ))}
    </div>
  );
};

export default NewsArticlesSection;
